'use client';

type Props = {
  title?: string;
};

export default function ErrorCard({ title = 'データ' }: Props) {
  return (
    <div className="flex h-full w-full items-center justify-center text-[14px] text-[#555555]">
      <p>{title}の取得に失敗しました。</p>
    </div>
  );
}
